var _circle, _circle2, _circle3, _circle4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path, _circle5, _circle6, _circle7, _circle8, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGomi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "15 -6 170 170",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "Gomi the bear",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gomi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 46,
    r: 22,
    fill: "#B5835A",
    stroke: "#4A3426",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 46,
    r: 11,
    fill: "#E8B6A0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 46,
    r: 22,
    fill: "#B5835A",
    stroke: "#4A3426",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 46,
    r: 11,
    fill: "#E8B6A0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 92,
    rx: 68,
    ry: 60,
    fill: "#B5835A",
    stroke: "#4A3426",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 114,
    rx: 11,
    ry: 6.5,
    fill: "#F7A8B8",
    opacity: 0.7
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142,
    cy: 114,
    rx: 11,
    ry: 6.5,
    fill: "#F7A8B8",
    opacity: 0.7
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 114,
    rx: 27,
    ry: 19,
    fill: "#EBCFAE"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 106,
    rx: 9,
    ry: 6.5,
    fill: "#4A3426"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97,
    cy: 104,
    rx: 3,
    ry: 1.8,
    fill: "#fff",
    opacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 116 Q95 123 100 117 Q105 123 110 116",
    fill: "none",
    stroke: "#4A3426",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 92,
    r: 6.5,
    fill: "#4A3426"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 89.5,
    r: 2.2,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 92,
    r: 6.5,
    fill: "#4A3426"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 89.5,
    r: 2.2,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52 Q62 12 100 12 Q138 12 140 52 Z",
    fill: "#FFD34E",
    stroke: "#4A3426",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95 15 h10 v35 h-10 Z",
    fill: "#FFE68F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 46,
    width: 100,
    height: 11,
    rx: 5.5,
    fill: "#FFC21A",
    stroke: "#4A3426",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGomi);
export default __webpack_public_path__ + "static/media/gomi.e04a4770eb819295b412a921da76e27f.svg";
export { ForwardRef as ReactComponent };